import { useLocation } from "@reach/router"
import { Layout as AntLayout, Popover } from "antd"
import "antd/dist/antd.css"
import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Helmet } from "react-helmet"
import { BsRobot } from "react-icons/bs"
import { RxCross2 } from "react-icons/rx"
import { RecoilRoot } from "recoil"
import TalkToUs from "../components/Talktous"
import "../styles/layout.scss"
import Chat from "./Chat"
import Footer from "./Footer"
import Header from "./Header"

const Layout = ({ children, className, data, style, pageTitle, descrip }) => {
  const { Content } = AntLayout
  const location = useLocation()

  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  const siteUrl = (site?.siteMetadata?.siteUrl || "https://visiomate.com").replace(/\/$/, "")

  // Build a clean, self-referencing canonical: fixed origin + normalized
  // pathname (no query string, no hash), with a single trailing slash to
  // match the sitemap. Uses pathname so it resolves correctly during SSR.
  const cleanPath = `${location.pathname || "/"}`.replace(/\/+$/, "")
  const canonicalUrl = `${siteUrl}${cleanPath}/`
  const [cookieModal, setCookieModal] = useState(true)
  const [user, setUser] = useState(null)
  const [botChat, setBotChat] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [showPreferences, setShowPreferences] = useState(false)
  const [analyticsOn, setAnalyticsOn] = useState(true)
  const [marketingOn, setMarketingOn] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShowPopup(true)
    }, 1000)
  }, [])

  const acceptCookie = () => {
    setCookieModal(false)
    localStorage.setItem("user", true)
  }
  const declineCookie = () => {
    setCookieModal(false)
    localStorage.setItem("user", false)
  }
  const savePreferences = () => {
    setCookieModal(false)
    localStorage.setItem("user", JSON.stringify({ analytics: analyticsOn, marketing: marketingOn }))
  }

  useEffect(() => {
    if (window !== undefined) {
      setUser(localStorage.getItem("user"))
    }
  }, [])

  const functionCallHandler = async (call) => {
    const args = JSON.parse(call.function.arguments)
    const response = await fetch(
      `https://staging.visiomate.com/create_consultancy/ai_query`,
      {
        method: "POST",
        body: JSON.stringify(args),
      }
    )
    let data = await response.text()
    return JSON.stringify(data)
  }

  return (
    <RecoilRoot>
      <AntLayout>
        <title>{pageTitle}</title>
        <Helmet>
          <meta name="description" content={descrip} />
          <link
            rel="canonical"
            href={canonicalUrl}
            key="canonical-link"
          />
        </Helmet>
        <Header data={data} />

        {/* ── Cookie consent ── */}
        {cookieModal && user === null && (
          <>
            {showPreferences && (
              <div className="ck-prefs">
                <div className="ck-prefs__head">
                  <h3 className="ck-prefs__title">Cookie preferences</h3>
                  <button className="ck-prefs__close" onClick={() => setShowPreferences(false)}>✕</button>
                </div>
                <p className="ck-prefs__why-label">Why we ask</p>
                <p className="ck-prefs__why-text">Pick which categories you're OK with. You can change this anytime.</p>
                <div className="ck-prefs__rows">
                  <div className="ck-prefs__row">
                    <span className="ck-prefs__row-name">Strictly necessary</span>
                    <div className="ck-toggle ck-toggle--locked"><div className="ck-toggle__track" /></div>
                  </div>
                  <div className="ck-prefs__row">
                    <span className="ck-prefs__row-name">Analytics</span>
                    <label className="ck-toggle">
                      <input type="checkbox" checked={analyticsOn} onChange={e => setAnalyticsOn(e.target.checked)} />
                      <div className="ck-toggle__track" />
                    </label>
                  </div>
                  <div className="ck-prefs__row">
                    <span className="ck-prefs__row-name">Marketing</span>
                    <label className="ck-toggle">
                      <input type="checkbox" checked={marketingOn} onChange={e => setMarketingOn(e.target.checked)} />
                      <div className="ck-toggle__track" />
                    </label>
                  </div>
                </div>
                <div className="ck-prefs__more">
                  <p className="ck-prefs__more-title">More information</p>
                  <p className="ck-prefs__more-text">
                    For details about what each category does and how to exercise your data rights, see our{" "}
                    <a href="/privacypolicy" className="ck-prefs__more-link">Privacy Policy</a>.
                  </p>
                </div>
                <div className="ck-prefs__actions">
                  <button className="ck-btn ck-btn--primary" onClick={acceptCookie}>Accept all</button>
                  <button className="ck-btn ck-btn--dark" onClick={declineCookie}>Reject all</button>
                  <button className="ck-btn ck-btn--dark" onClick={savePreferences}>Save preferences</button>
                </div>
              </div>
            )}
            <div className="ck-banner">
              <div className="ck-banner__left">
                <h3 className="ck-banner__title">We use a few cookies.</h3>
                <p className="ck-banner__desc">
                  Some are required for the site to work. Others help us understand which pages
                  perform — only if you opt in. We don't sell your data, and you can change your mind anytime.
                </p>
                <a href="/privacypolicy" className="ck-banner__policy">Privacy Policy</a>
              </div>
              <div className="ck-banner__actions">
                <button className="ck-btn ck-btn--primary" onClick={acceptCookie}>Accept all</button>
                <button className="ck-btn ck-btn--dark" onClick={declineCookie}>Reject all</button>
                <button className="ck-btn ck-btn--outline" onClick={() => setShowPreferences(p => !p)}>
                  Manage preferences
                </button>
              </div>
            </div>
          </>
        )}
        <div
          style={{ position: "fixed", bottom: "10px", right: "15px", zIndex: 1100 }}
        >
          <div style={{ position: "relative" }}>
            {!!showPopup && <div className='opener'>
              <span>Do you have any question? 😀</span>
              <span>Visiomate's team is online</span>
              <button className='chatbtn' onClick={() => {
                setBotChat(true);
              }}>Chat with Visiomate's Team</button>
              <button onClick={(e) => {
                e.preventDefault();
                setShowPopup(false);
              }} className='popup-close'><RxCross2 /></button>
            </div>}
            <button
              className="accept_btn cookie_button bot-button"
              style={{ borderRadius: '50% !important' }}
              onClick={(e) => {
                e.preventDefault()
                setShowPopup(false)
                setBotChat(!botChat)
              }}
            >
              <p className="botPara">
                {!botChat ? <BsRobot className="botIcon" /> : <RxCross2 className="botIcon" />}
              </p>
            </button>
            {botChat && <Chat functionCallHandler={functionCallHandler} setBotChat={setBotChat} />}
          </div>
        </div>

        <Content className={className} style={style}>
          {children}
        </Content>
        {/* {!(
          location.pathname.includes("privacypolicy") ||
          location.pathname.includes("userdeletionpolicy")
        ) && <TalkToUs />} */}
        <Footer data={data} />
      </AntLayout>
    </RecoilRoot>
  )
}

export default Layout
